import { render, staticRenderFns } from "./blog-video.vue?vue&type=template&id=37a6c28c&scoped=true&"
import script from "./blog-video.vue?vue&type=script&lang=js&"
export * from "./blog-video.vue?vue&type=script&lang=js&"
import style0 from "./blog-video.vue?vue&type=style&index=0&id=37a6c28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a6c28c",
  null
  
)

export default component.exports